import { handleActions } from "redux-actions";

import localize from "../../../localization/container";
import * as apiActions from "../actions";

const defaultState = {
  error: "",
  quintessentialData: [],
  triageData: [],
  suiteQtData:[],
  runId:[],
  quintessentialJobId:{}
};

export const quintessential = handleActions(
  {
    [apiActions.quintessitalSuccess]: (state, action) => {
      return {
        ...state,
        quintessentialData: action.payload,
      };
    },
    [apiActions.quintessitalClear]: (state, action) => {
      return {
        ...state,
        quintessentialData: [],
      };
    },
    [apiActions.getJobIdSuccess]: (state, action) => {
      return {
        ...state,
        quintessentialJobId: action.payload,
      };
    },
    [apiActions.getJobIdClear]: (state, action) => {
      return {
        ...state,
        quintessentialJobId: {},
      };
    },
    [apiActions.triageDataSuccess]: (state, action) => {
      return {
        ...state,
        triageData: action.payload,
      };
    }, 
    [apiActions.suiteQtRunIdDataSuccess]: (state, action) => {
      return {
        ...state,
        runId: action.payload,
      };
    },  
    [apiActions.suiteQtRunIdDataSuccess]: (state, action) => {
      return {
        ...state,
        runId: action.payload,
      };
    },
    [apiActions.suiteQtDataSuccess]: (state, action) => {
      return {
        ...state,
        suiteQtData: action.payload,
      };
    },
  },
  defaultState
);
